
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"13","height":"13","viewBox":"0 0 13 13"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#C3AFA3"}},[_c('circle',{attrs:{"cx":"5.281","cy":"3.384","r":"1.219"}}),_c('path',{attrs:{"d":"M9.163 4.718a.556.556 0 00-.496-.3.545.545 0 00-.483.318l-.844 1.86a.135.135 0 01-.229.03l-.444-.556a.542.542 0 00-.867.028L4.111 8.51a.27.27 0 00.222.428h6.5a.27.27 0 00.242-.392L9.163 4.718z"}}),_c('path',{attrs:{"d":"M11.917 0H2.979c-.598 0-1.083.485-1.083 1.083v8.938c0 .598.485 1.083 1.083 1.083h8.938c.598 0 1.083-.485 1.083-1.083V1.083C13 .485 12.515 0 11.917 0zm-.079 9.942a.27.27 0 01-.192.079H3.25a.27.27 0 01-.27-.271V1.354c0-.15.12-.27.27-.27h8.396c.15 0 .27.12.27.27V9.75a.27.27 0 01-.078.19v.002z"}}),_c('path',{attrs:{"d":"M10.563 11.917H1.354a.27.27 0 01-.27-.271V2.437a.542.542 0 10-1.084 0v9.48C0 12.515.485 13 1.083 13h9.48a.542.542 0 000-1.083z"}})])])
          )
        }
      }
    